import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin } from "lucide-react";
export const Footer = () => {
  return <footer className="bg-accent text-accent-foreground">
      <div className="container mx-auto px-4 py-8 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="font-display text-xl md:text-2xl font-bold mb-3 md:mb-4 text-primary-foreground">
              Azur Hybrid Luxe
            </h3>
            <p className="text-accent-foreground/80 mb-4 md:mb-6 text-sm md:text-base">
              Votre chauffeur VTC de confiance sur la Côte d'Azur. 
              Service premium, véhicules hybrides, confort absolu.
            </p>
            {/* Réseaux sociaux désactivés - en attente des comptes professionnels */}
            <div className="flex gap-4">
              <span className="text-primary-foreground/50 cursor-not-allowed" aria-label="Facebook (bientôt disponible)">
                <Facebook className="h-6 w-6 md:h-7 md:w-7" />
              </span>
              <span className="text-primary-foreground/50 cursor-not-allowed" aria-label="Instagram (bientôt disponible)">
                <Instagram className="h-6 w-6 md:h-7 md:w-7" />
              </span>
              <span className="text-primary-foreground/50 cursor-not-allowed" aria-label="LinkedIn (bientôt disponible)">
                <Linkedin className="h-6 w-6 md:h-7 md:w-7" />
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-base md:text-lg font-semibold mb-3 md:mb-4">Liens rapides</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/services" className="text-accent-foreground/80 hover:text-primary transition-colors text-sm md:text-base">
                  Nos services
                </Link>
              </li>
              <li>
                <Link to="/flotte" className="text-accent-foreground/80 hover:text-primary transition-colors text-sm md:text-base">
                  Notre flotte
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="text-accent-foreground/80 hover:text-primary transition-colors text-sm md:text-base">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/reservation" className="text-accent-foreground/80 hover:text-primary transition-colors text-sm md:text-base">
                  Réservation
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-accent-foreground/80 hover:text-primary transition-colors text-sm md:text-base">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-base md:text-lg font-semibold mb-3 md:mb-4">Contact</h4>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-center gap-2 md:gap-3">
                <Phone className="h-4 w-4 text-slate-900 flex-shrink-0" />
                <a href="tel:+33618361573" className="text-accent-foreground/80 hover:text-primary transition-colors text-sm md:text-base">+33 6 18 36 15 73</a>
              </li>
              <li className="flex items-center gap-2 md:gap-3">
                <Mail className="h-4 w-4 text-slate-900 flex-shrink-0" />
                <a className="text-accent-foreground/80 hover:text-primary transition-colors text-sm md:text-base break-all" href="mailto:contact@azurhybridluxe.com">
                  contact@azurhybridluxe.com
                </a>
              </li>
              <li className="flex items-start gap-2 md:gap-3">
                <MapPin className="h-4 w-4 text-slate-900 mt-1 flex-shrink-0" />
                <span className="text-accent-foreground/80 text-sm md:text-base">
                  Nice, Côte d'Azur, France
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-display text-base md:text-lg font-semibold mb-3 md:mb-4">Disponibilité</h4>
            <div className="flex items-start gap-2 md:gap-3">
              <Clock className="h-4 w-4 text-slate-900 mt-1 flex-shrink-0" />
              <div className="text-accent-foreground/80">
                <p className="font-semibold text-sm md:text-base">24h/24, 7j/7</p>
                <p className="mt-2 text-xs md:text-sm">
                  Service disponible tous les jours, y compris les jours fériés
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-accent-foreground/10 mt-8 md:mt-12 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-accent-foreground/90 text-xs md:text-sm text-center md:text-left">
            © {new Date().getFullYear()} Azur Hybrid Luxe. Tous droits réservés.
          </p>
          <div className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6 text-xs md:text-sm">
            <Link to="/cgv" className="text-accent-foreground/90 hover:text-primary transition-colors">
              CGV
            </Link>
            <Link to="/mentions-legales" className="text-accent-foreground/90 hover:text-primary transition-colors">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="text-accent-foreground/90 hover:text-primary transition-colors">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};